import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  HomeHero,
  RetirementPlanGridTableWrap,
  TargetDateGrid,
  OneTwoThree,
  RiskTypeLinks,
  HomeTestimonials,
  HomeEduCenter,
  IyvBanner,
  SignupForm,
  AutocompleteSearch,
  AykCtaPanel,
} from '../../components'

import Styles from './Home.css'


@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Home',
      description: config.app.description,
      url: config.domain
    }
  }

  render() {
    const goodBadImg = require('../../../static/images/good-and-bad.jpg')
    //
    return (
      <div>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <HomeHero />

        <IyvBanner />

        <AykCtaPanel />
        
        <div id='h-plans' />
        <ContainerDivs>
          <h2 styleName='plan-logos-label'>
            401(k)s and similar retirement plans
          </h2>

          <p styleName='plan-logos-p'>
            We've rated 70+ employer-offered retirement plans for
            investments in fossil fuels, deforestation, weapons,
            private prisons, and more.
          </p>

        </ContainerDivs>
        <RetirementPlanGridTableWrap/>
        <div styleName='signup-box'>
          <ContainerDivs>
            <div styleName='signup-box-inner'>
              <div styleName='signup-box-label'>
                <h2>
                  Get alerted when your employer's plan is rated
                </h2>
              </div>
              <SignupForm/>
            </div>
          </ContainerDivs>
        </div>
        <div id='h-funds' />
        <div styleName='search-box'>
          <ContainerDivs>
            <div styleName='search-box-inner'>
              <div styleName='search-box-search'>
                <div styleName='search-box-label'>
                  <h1>
                    Check if your mutual funds and ETFs are climate safe
                  </h1>
                </div>
                <br/>
                <AutocompleteSearch />
                <div styleName='search-box-link'>
                  <Link
                    to={config.routes.clean}
                    title={'Full list'}
                  >
                    Full list<LinkIcon />
                  </Link>
                </div>
              </div>
              <div styleName='search-box-img'>
                <img
                  src={goodBadImg}
                  alt='Search mutual funds'
                />
              </div>
            </div>
          </ContainerDivs>
        </div>
        <div id='h-target-dates' />
        <ContainerDivs>
          <div styleName='signup-box-label-2'>
            <h2>
              Target date fund series
            </h2>
            <p>
              Don't see your company above? Check if your plan's default option
              is one of the target date fund series below.
            </p>
            <br/>
          </div>
          <TargetDateGrid />
        </ContainerDivs>
        <OneTwoThree />
        <HomeEduCenter />
        <RiskTypeLinks />
        <HomeTestimonials />
      </div>
    )
  }
}

